var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-circular-progress',{attrs:{"show-value":"","size":"lg","indeterminate":_vm.isIndeterminate,"thickness":0.2,"color":_vm.color,"track-color":"grey-8","value":_vm.value}},[_vm._v("\n  "+_vm._s(_vm.showMsg)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }